var _path, _path2, _circle, _circle2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F625(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD67",
    d: "M2 32c0 16.572 13.428 30 30 30s30-13.428 30-30S48.572 2 32 2 2 15.428 2 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#65B1EF",
    d: "M47.688 37.605c0 8.576 11.656 8.578 11.654 0 0-6.264-5.826-12.375-5.826-12.375s-5.828 6.114-5.828 12.375z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 38.498,
    cy: 35,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 15.498,
    cy: 35,
    r: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#917524"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.578 19.906a14.232 14.232 0 0 1-11.693 3.133c-.578-.113-1.088 2.021-.385 2.156a16.42 16.42 0 0 0 13.492-3.615c.541-.469-.971-2.06-1.414-1.674zM45.113 22.887c-4.168.748-8.455-.4-11.691-3.133-.443-.389-1.955 1.205-1.412 1.674a16.418 16.418 0 0 0 13.492 3.615c.703-.135.191-2.27-.389-2.156z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M38.074 47.33c-5.766-1.549-12.049-.428-16.93 3.014-1.205.869 1.053 4.027 2.252 3.152 3.223-2.268 8.352-3.834 13.66-2.432 1.423.377 2.536-3.308 1.018-3.734z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F625);
export default __webpack_public_path__ + "static/media/1f625.4d968c0ae692c29e8d5aef5d230790b5.svg";
export { ForwardRef as ReactComponent };